import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=fed6505e&scoped=true&"
import script from "./BookList.vue?vue&type=script&lang=js&"
export * from "./BookList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed6505e",
  null
  
)

export default component.exports